import { useParams } from 'react-router-dom'

import TimeTrackingPolicy from 'modules/attendance/components/SettingItemPage/TimeTracking/TimeTrackingPolicy'
import { isOfTypeTabs } from 'modules/attendance/lib/tabs'

const SettingsItemPage = () => {
  const { settingId, tabId = 'edit' } = useParams()

  if (!isOfTypeTabs(tabId)) {
    throw new Error('Invalid tabId')
  }

  return (
    <TimeTrackingPolicy
      settingId={settingId === 'default' ? settingId : Number(settingId)}
      tabId={tabId}
    />
  )
}

export default SettingsItemPage
